import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { WorkflowWorkItem } from '../../types/generated.types';
import { ApiConversionHelper } from '../../helpers/api-conversion.helper';

@Injectable({ providedIn: 'root' })
export class WorkflowWorkItemsApiService extends BaseApiService {
  protected get baseUrl(): string {
    return `${super.baseUrl}/workflow-work-items`;
  }

  async getWorkflowWorkItems(): Promise<WorkflowWorkItem[]> {
    const workItems = await this.get<WorkflowWorkItem[]>('');
    workItems.forEach(item => ApiConversionHelper.convertWorkflowWorkItem(item));
    return workItems;
  }

  async getWorkflowWorkItem(id: string): Promise<WorkflowWorkItem> {
    const workItem = await this.get<WorkflowWorkItem>(id);
    ApiConversionHelper.convertWorkflowWorkItem(workItem);
    return workItem;
  }

  async assignToMe(id: string): Promise<void> {
    return await this.post(`${id}/assign-to-me`, {});
  }

  async updateFormData(id: string, formData: Record<string, any>): Promise<void> {
    return await this.put(`${id}/form-data`, { formData });
  }

  async completeWorkItem(id: string, formData: Record<string, any>, actionResult: string): Promise<void> {
    return await this.post(`${id}/complete`, { formData, actionResult });
  }
}
